module.exports = __webpack_public_path__ + "img/4@3x.c2328fd8.png";